import React from 'react';
import styles from './MandalaBackground.module.css';
import mandala from 'assets/images/mandala.png'

const MandalaBackground = () => {
    return (
        <img src={mandala} alt="Decorative mandala" className={styles.mandala} />
    );
};

export default MandalaBackground;